import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';// eslint-disable-line no-unused-vars
import Checkbox from 'material-ui/Checkbox';
import Alert from '../home/Alert'
import { updateGiftCard } from '../../actions';
import _ from 'lodash'

const propTypes = {
  giftcards: PropTypes.any,
  giftcard: PropTypes.object,
  onSave: PropTypes.func,
};

class EditGiftCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edited: false,
      open: false,
      alertOpen: false,
      giftcard: {
        id: 0,
        code: '',
        disabled: false,
        principal: 0,
        balance: 0,
        purchaserName: '',
        purchaserEmail: '',
        recipientName: '',
        recipientEmail: '',
        datePurchased: new Date(),
        expiration: new Date(),
        message: '',
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    const { giftcard } = nextProps;
    this.setState({ giftcard });
    if (nextProps.giftcard && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        error: false,
        giftcard,
        alertMessage: 'Gift Card saved successfully!',
        edited: false,
      });
    }
  }
  navigateToView() {
    browserHistory.push(`/giftcards/view/${this.state.giftcard.id}`);
  }
  saveChanges() {
    console.clear();
    const balance = (this.state.giftcard.balance === '') ? 0 : this.state.giftcard.balance;
    const disabled = this.state.giftcard.disabled
    this.props.dispatch(updateGiftCard(this.state.giftcard.id, { balance: balance, disabled: disabled }));
  }
  handleCancel() {
    browserHistory.push('/giftcards?page=1');
  }
  handleChange(e){
    const giftcard = this.state.giftcard
      if (e.target.type === 'checkbox') {
        _.set(giftcard, e.target.name, e.target.checked);
    } else {
        _.set(giftcard, e.target.name, e.target.value);
    }
    this.setState({
      giftcard: giftcard,
      edited: true,
    })
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
  }
  render() {
    const styles = {
      scrollDivStyle: {
        width: '250px',
        display: 'inline-block',
        color: cyan900,
        fontSize: '12px',
        marginTop: '10px',
      },
      listStyle: {
        display: 'inline-block',
        verticalAlign: 'text-top',
        height: '70px',
        overflow: 'auto',
      },
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
    };
    const expire = (this.props.giftcard.expiration) ? new Date(this.props.giftcard.expiration).toLocaleDateString() : '';
    const purchase = (this.props.giftcard.datePurchased) ? new Date(this.props.giftcard.datePurchased).toLocaleDateString() : '';
    return (
      <div>
      <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="float-right">
          <RaisedButton
            style={{ marginRight: '20px' }}
            label="Cancel"
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            style={{ marginRight: '20px' }}
            label="View"
            primary
            onClick={this.navigateToView}
          />
          <RaisedButton
            style={{ marginRight: '20px' }}
            label="Save"
            primary
            onClick={this.saveChanges}
          />
        </div>
        <br />
        <TextField
          floatingLabelText="Gift Card Code"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.code || ''}
          name="code"
          style={styles.inputStyle}
          disabled
        />
        <br />
        <TextField
          floatingLabelText="Purchaser Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.purchaserName || ''}
          name="purchaserName"
          style={styles.inputStyle}
          disabled
        />
        <TextField
          floatingLabelText="Purchaser Email"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.purchaserEmail || ''}
          name="purchaserEmail"
          style={styles.inputStyle}
          disabled
        />
        <TextField
          floatingLabelText="Recipient Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.recipientName || ''}
          name="recipientName"
          style={styles.inputStyle}
          disabled
        />
        <TextField
          floatingLabelText="Recipient Email"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.recipientEmail || ''}
          name="recipientEmail"
          style={styles.inputStyle}
          disabled
        />
        <br />
        <TextField
          floatingLabelText="Principal"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.principal || ''}
          name="recipientName"
          style={styles.inputStyle}
          disabled
        />
        <TextField
          floatingLabelText="Balance"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.balance || this.state.giftcard.balance}
          onChange ={this.handleChange}
          name="balance"
          style={styles.inputStyle}

        />
        <TextField
          floatingLabelText="Date Purchased"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={purchase}
          name="datePurchased"
          style={styles.inputStyle}
          disabled
        />
        <TextField
          floatingLabelText="Date Expires"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={expire}
          name="expiration"
          style={styles.inputStyle}
          disabled
        />
        <br />
        <br />
        <TextField
          floatingLabelText="Gift Card Message"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.message || ''}
          name="message"
          multiLine
          underlineShow={false}
          rows={10}
          rowsMax={10}
          style={{ width: '60%' }}
          textareaStyle={{ border: '1px solid black' }}
          disabled
        />
        <br />
        <ul>
          <li>
            <Checkbox
              label="Disabled"
              checked={this.state.giftcard.disabled}
              name="disabled"
              onCheck={this.handleChange}
            />
          </li>
        </ul>
      </div>
    );
  }
}

EditGiftCard.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditGiftCard.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    giftcards: state.giftCards,
    giftcard: state.giftCards.giftcard,
  };
}

export default connect(mapStateToProps)(EditGiftCard);


// WEBPACK FOOTER //
// ./src/components/giftCards/EditGiftCard.js